/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApplicationsCount,
    ApplicationsCountFromJSON,
    ApplicationsCountToJSON,
    CandidateOfferItemPaginated,
    CandidateOfferItemPaginatedFromJSON,
    CandidateOfferItemPaginatedToJSON,
    CompanyApplication,
    CompanyApplicationFromJSON,
    CompanyApplicationToJSON,
    CompanyApplicationFilers,
    CompanyApplicationFilersFromJSON,
    CompanyApplicationFilersToJSON,
    CompanyApplicationItem,
    CompanyApplicationItemFromJSON,
    CompanyApplicationItemToJSON,
    CompanyCompany,
    CompanyCompanyFromJSON,
    CompanyCompanyToJSON,
    CompanyOffer,
    CompanyOfferFromJSON,
    CompanyOfferToJSON,
    CompanyOfferFilters,
    CompanyOfferFiltersFromJSON,
    CompanyOfferFiltersToJSON,
    CompanyPaginatedOfferItems,
    CompanyPaginatedOfferItemsFromJSON,
    CompanyPaginatedOfferItemsToJSON,
    CompanyUser,
    CompanyUserFromJSON,
    CompanyUserToJSON,
    DefaultResponse,
    DefaultResponseFromJSON,
    DefaultResponseToJSON,
    OffersCount,
    OffersCountFromJSON,
    OffersCountToJSON,
    Status,
    StatusFromJSON,
    StatusToJSON,
} from '../models';

export interface CompanyApplicationsIdGetRequest {
    id: number;
}

export interface CompanyApplicationsIdPutRequest {
    id: number;
    status?: Status;
}

export interface CompanyCompanyPostRequest {
    companyCompany?: CompanyCompany;
}

export interface CompanyDocumentIdDownloadGetRequest {
    id: number;
}

export interface CompanyLogoPostRequest {
    file?: Blob;
}

export interface CompanyOffersCountGetRequest {
    modalities?: string;
    presences?: string;
    states?: string;
    academicPrograms?: string;
    archived?: boolean;
    status?: number;
    page?: number;
    limit?: number;
}

export interface CompanyOffersFiltersGetRequest {
    status?: number;
}

export interface CompanyOffersGetRequest {
    modalities?: string;
    presences?: string;
    states?: string;
    academicPrograms?: string;
    archived?: boolean;
    status?: number;
    page?: number;
    limit?: number;
}

export interface CompanyOffersIdApplicationsCountGetRequest {
    id: number;
    status?: string;
    academicPrograms?: string;
    minAcademicProgramPercent?: number;
    maxAcademicProgramPercent?: number;
    minQuestionsPercent?: number;
    maxQuestionsPercent?: number;
    states?: string;
    order?: string;
    orderType?: string;
}

export interface CompanyOffersIdApplicationsFiltersGetRequest {
    id: number;
    status?: string;
}

export interface CompanyOffersIdApplicationsGetRequest {
    id: number;
    status?: string;
    academicPrograms?: string;
    minAcademicProgramPercent?: number;
    maxAcademicProgramPercent?: number;
    minQuestionsPercent?: number;
    maxQuestionsPercent?: number;
    states?: string;
    order?: string;
    orderType?: string;
}

export interface CompanyOffersIdGetRequest {
    id: number;
}

export interface CompanyOffersIdPutRequest {
    id: number;
    companyOffer?: CompanyOffer;
}

export interface CompanyOffersIdStatusPutRequest {
    id: number;
    status?: Status;
}

export interface CompanyOffersLikeCandidateGetRequest {
    applied?: boolean;
    company?: number;
    modalities?: string;
    presences?: string;
    states?: string;
    academicPrograms?: string;
    status?: string;
    page?: number;
    limit?: number;
}

export interface CompanyOffersPostRequest {
    companyOffer?: CompanyOffer;
}

export interface CompanyUserPostRequest {
    companyUser?: CompanyUser;
}

export interface CompanyViewLogoLogoGetRequest {
    logo: string;
}

/**
 * 
 */
export class CompanyApi extends runtime.BaseAPI {

    /**
     * [P_E_07]
     */
    async companyApplicationsIdGetRaw(requestParameters: CompanyApplicationsIdGetRequest): Promise<runtime.ApiResponse<CompanyApplication>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companyApplicationsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/applications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyApplicationFromJSON(jsonValue));
    }

    /**
     * [P_E_07]
     */
    async companyApplicationsIdGet(requestParameters: CompanyApplicationsIdGetRequest): Promise<CompanyApplication> {
        const response = await this.companyApplicationsIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Cambia el status de la candidatura y guarda un event [P_E_07]
     */
    async companyApplicationsIdPutRaw(requestParameters: CompanyApplicationsIdPutRequest): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companyApplicationsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company/applications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StatusToJSON(requestParameters.status),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Cambia el status de la candidatura y guarda un event [P_E_07]
     */
    async companyApplicationsIdPut(requestParameters: CompanyApplicationsIdPutRequest): Promise<boolean> {
        const response = await this.companyApplicationsIdPutRaw(requestParameters);
        return await response.value();
    }

    /**
     * Perfil de la empresa logueada [P_E_16]
     */
    async companyCompanyGetRaw(): Promise<runtime.ApiResponse<CompanyCompany>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/company`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyCompanyFromJSON(jsonValue));
    }

    /**
     * Perfil de la empresa logueada [P_E_16]
     */
    async companyCompanyGet(): Promise<CompanyCompany> {
        const response = await this.companyCompanyGetRaw();
        return await response.value();
    }

    /**
     * [P_E_16]
     */
    async companyCompanyPostRaw(requestParameters: CompanyCompanyPostRequest): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company/company`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyCompanyToJSON(requestParameters.companyCompany),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * [P_E_16]
     */
    async companyCompanyPost(requestParameters: CompanyCompanyPostRequest): Promise<boolean> {
        const response = await this.companyCompanyPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * [P_E_07]
     */
    async companyDocumentIdDownloadGetRaw(requestParameters: CompanyDocumentIdDownloadGetRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companyDocumentIdDownloadGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/document/{id}/download`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * [P_E_07]
     */
    async companyDocumentIdDownloadGet(requestParameters: CompanyDocumentIdDownloadGetRequest): Promise<Blob> {
        const response = await this.companyDocumentIdDownloadGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Subida del un nuevo logo de empresa
     */
    async companyLogoPostRaw(requestParameters: CompanyLogoPostRequest): Promise<runtime.ApiResponse<DefaultResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/company/logo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultResponseFromJSON(jsonValue));
    }

    /**
     * Subida del un nuevo logo de empresa
     */
    async companyLogoPost(requestParameters: CompanyLogoPostRequest): Promise<DefaultResponse> {
        const response = await this.companyLogoPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Contador ofertas para filtro
     */
    async companyOffersCountGetRaw(requestParameters: CompanyOffersCountGetRequest): Promise<runtime.ApiResponse<OffersCount>> {
        const queryParameters: any = {};

        if (requestParameters.modalities !== undefined) {
            queryParameters['modalities'] = requestParameters.modalities;
        }

        if (requestParameters.presences !== undefined) {
            queryParameters['presences'] = requestParameters.presences;
        }

        if (requestParameters.states !== undefined) {
            queryParameters['states'] = requestParameters.states;
        }

        if (requestParameters.academicPrograms !== undefined) {
            queryParameters['academic_programs'] = requestParameters.academicPrograms;
        }

        if (requestParameters.archived !== undefined) {
            queryParameters['archived'] = requestParameters.archived;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/offers_count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OffersCountFromJSON(jsonValue));
    }

    /**
     * Contador ofertas para filtro
     */
    async companyOffersCountGet(requestParameters: CompanyOffersCountGetRequest): Promise<OffersCount> {
        const response = await this.companyOffersCountGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Filter data offer company
     */
    async companyOffersFiltersGetRaw(requestParameters: CompanyOffersFiltersGetRequest): Promise<runtime.ApiResponse<CompanyOfferFilters>> {
        const queryParameters: any = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/offers_filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyOfferFiltersFromJSON(jsonValue));
    }

    /**
     * Filter data offer company
     */
    async companyOffersFiltersGet(requestParameters: CompanyOffersFiltersGetRequest): Promise<CompanyOfferFilters> {
        const response = await this.companyOffersFiltersGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Lista de las ofertas de la empresa logueada [P_E_01] [P_E_02] [P_E_03]
     */
    async companyOffersGetRaw(requestParameters: CompanyOffersGetRequest): Promise<runtime.ApiResponse<CompanyPaginatedOfferItems>> {
        const queryParameters: any = {};

        if (requestParameters.modalities !== undefined) {
            queryParameters['modalities'] = requestParameters.modalities;
        }

        if (requestParameters.presences !== undefined) {
            queryParameters['presences'] = requestParameters.presences;
        }

        if (requestParameters.states !== undefined) {
            queryParameters['states'] = requestParameters.states;
        }

        if (requestParameters.academicPrograms !== undefined) {
            queryParameters['academic_programs'] = requestParameters.academicPrograms;
        }

        if (requestParameters.archived !== undefined) {
            queryParameters['archived'] = requestParameters.archived;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/offers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyPaginatedOfferItemsFromJSON(jsonValue));
    }

    /**
     * Lista de las ofertas de la empresa logueada [P_E_01] [P_E_02] [P_E_03]
     */
    async companyOffersGet(requestParameters: CompanyOffersGetRequest): Promise<CompanyPaginatedOfferItems> {
        const response = await this.companyOffersGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Contador de inscritos dentro de la oferta [P_E_05] [P_E_06]
     */
    async companyOffersIdApplicationsCountGetRaw(requestParameters: CompanyOffersIdApplicationsCountGetRequest): Promise<runtime.ApiResponse<ApplicationsCount>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companyOffersIdApplicationsCountGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.academicPrograms !== undefined) {
            queryParameters['academic_programs'] = requestParameters.academicPrograms;
        }

        if (requestParameters.minAcademicProgramPercent !== undefined) {
            queryParameters['min_academic_program_percent'] = requestParameters.minAcademicProgramPercent;
        }

        if (requestParameters.maxAcademicProgramPercent !== undefined) {
            queryParameters['max_academic_program_percent'] = requestParameters.maxAcademicProgramPercent;
        }

        if (requestParameters.minQuestionsPercent !== undefined) {
            queryParameters['min_questions_percent'] = requestParameters.minQuestionsPercent;
        }

        if (requestParameters.maxQuestionsPercent !== undefined) {
            queryParameters['max_questions_percent'] = requestParameters.maxQuestionsPercent;
        }

        if (requestParameters.states !== undefined) {
            queryParameters['states'] = requestParameters.states;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.orderType !== undefined) {
            queryParameters['order_type'] = requestParameters.orderType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/offers/{id}/applications_count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationsCountFromJSON(jsonValue));
    }

    /**
     * Contador de inscritos dentro de la oferta [P_E_05] [P_E_06]
     */
    async companyOffersIdApplicationsCountGet(requestParameters: CompanyOffersIdApplicationsCountGetRequest): Promise<ApplicationsCount> {
        const response = await this.companyOffersIdApplicationsCountGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Información de filtro para inscripciones
     */
    async companyOffersIdApplicationsFiltersGetRaw(requestParameters: CompanyOffersIdApplicationsFiltersGetRequest): Promise<runtime.ApiResponse<CompanyApplicationFilers>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companyOffersIdApplicationsFiltersGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/offers/{id}/applications_filters`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyApplicationFilersFromJSON(jsonValue));
    }

    /**
     * Información de filtro para inscripciones
     */
    async companyOffersIdApplicationsFiltersGet(requestParameters: CompanyOffersIdApplicationsFiltersGetRequest): Promise<CompanyApplicationFilers> {
        const response = await this.companyOffersIdApplicationsFiltersGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Listado de inscritos dentro de la oferta [P_E_05] [P_E_06]
     */
    async companyOffersIdApplicationsGetRaw(requestParameters: CompanyOffersIdApplicationsGetRequest): Promise<runtime.ApiResponse<Array<CompanyApplicationItem>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companyOffersIdApplicationsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.academicPrograms !== undefined) {
            queryParameters['academic_programs'] = requestParameters.academicPrograms;
        }

        if (requestParameters.minAcademicProgramPercent !== undefined) {
            queryParameters['min_academic_program_percent'] = requestParameters.minAcademicProgramPercent;
        }

        if (requestParameters.maxAcademicProgramPercent !== undefined) {
            queryParameters['max_academic_program_percent'] = requestParameters.maxAcademicProgramPercent;
        }

        if (requestParameters.minQuestionsPercent !== undefined) {
            queryParameters['min_questions_percent'] = requestParameters.minQuestionsPercent;
        }

        if (requestParameters.maxQuestionsPercent !== undefined) {
            queryParameters['max_questions_percent'] = requestParameters.maxQuestionsPercent;
        }

        if (requestParameters.states !== undefined) {
            queryParameters['states'] = requestParameters.states;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.orderType !== undefined) {
            queryParameters['order_type'] = requestParameters.orderType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/offers/{id}/applications`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompanyApplicationItemFromJSON));
    }

    /**
     * Listado de inscritos dentro de la oferta [P_E_05] [P_E_06]
     */
    async companyOffersIdApplicationsGet(requestParameters: CompanyOffersIdApplicationsGetRequest): Promise<Array<CompanyApplicationItem>> {
        const response = await this.companyOffersIdApplicationsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async companyOffersIdGetRaw(requestParameters: CompanyOffersIdGetRequest): Promise<runtime.ApiResponse<CompanyOffer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companyOffersIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/offers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyOfferFromJSON(jsonValue));
    }

    /**
     */
    async companyOffersIdGet(requestParameters: CompanyOffersIdGetRequest): Promise<CompanyOffer> {
        const response = await this.companyOffersIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Guardar oferta
     */
    async companyOffersIdPutRaw(requestParameters: CompanyOffersIdPutRequest): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companyOffersIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company/offers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyOfferToJSON(requestParameters.companyOffer),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Guardar oferta
     */
    async companyOffersIdPut(requestParameters: CompanyOffersIdPutRequest): Promise<boolean> {
        const response = await this.companyOffersIdPutRaw(requestParameters);
        return await response.value();
    }

    /**
     * Publicar oferta
     */
    async companyOffersIdStatusPutRaw(requestParameters: CompanyOffersIdStatusPutRequest): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companyOffersIdStatusPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company/offers/{id}/status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StatusToJSON(requestParameters.status),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Publicar oferta
     */
    async companyOffersIdStatusPut(requestParameters: CompanyOffersIdStatusPutRequest): Promise<boolean> {
        const response = await this.companyOffersIdStatusPutRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async companyOffersLikeCandidateGetRaw(requestParameters: CompanyOffersLikeCandidateGetRequest): Promise<runtime.ApiResponse<CandidateOfferItemPaginated>> {
        const queryParameters: any = {};

        if (requestParameters.applied !== undefined) {
            queryParameters['applied'] = requestParameters.applied;
        }

        if (requestParameters.company !== undefined) {
            queryParameters['company'] = requestParameters.company;
        }

        if (requestParameters.modalities !== undefined) {
            queryParameters['modalities'] = requestParameters.modalities;
        }

        if (requestParameters.presences !== undefined) {
            queryParameters['presences'] = requestParameters.presences;
        }

        if (requestParameters.states !== undefined) {
            queryParameters['states'] = requestParameters.states;
        }

        if (requestParameters.academicPrograms !== undefined) {
            queryParameters['academic_programs'] = requestParameters.academicPrograms;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/offers_like_candidate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CandidateOfferItemPaginatedFromJSON(jsonValue));
    }

    /**
     */
    async companyOffersLikeCandidateGet(requestParameters: CompanyOffersLikeCandidateGetRequest): Promise<CandidateOfferItemPaginated> {
        const response = await this.companyOffersLikeCandidateGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Nueva oferta
     */
    async companyOffersPostRaw(requestParameters: CompanyOffersPostRequest): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company/offers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyOfferToJSON(requestParameters.companyOffer),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Nueva oferta
     */
    async companyOffersPost(requestParameters: CompanyOffersPostRequest): Promise<boolean> {
        const response = await this.companyOffersPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Perfil del usuario logueado [P_E_15]
     */
    async companyUserGetRaw(): Promise<runtime.ApiResponse<CompanyUser>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyUserFromJSON(jsonValue));
    }

    /**
     * Perfil del usuario logueado [P_E_15]
     */
    async companyUserGet(): Promise<CompanyUser> {
        const response = await this.companyUserGetRaw();
        return await response.value();
    }

    /**
     * Perfil del usuario logueado [P_E_15]
     */
    async companyUserPostRaw(requestParameters: CompanyUserPostRequest): Promise<runtime.ApiResponse<DefaultResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company/user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyUserToJSON(requestParameters.companyUser),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultResponseFromJSON(jsonValue));
    }

    /**
     * Perfil del usuario logueado [P_E_15]
     */
    async companyUserPost(requestParameters: CompanyUserPostRequest): Promise<DefaultResponse> {
        const response = await this.companyUserPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Ver logo
     */
    async companyViewLogoLogoGetRaw(requestParameters: CompanyViewLogoLogoGetRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.logo === null || requestParameters.logo === undefined) {
            throw new runtime.RequiredError('logo','Required parameter requestParameters.logo was null or undefined when calling companyViewLogoLogoGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/view-logo/{logo}`.replace(`{${"logo"}}`, encodeURIComponent(String(requestParameters.logo))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Ver logo
     */
    async companyViewLogoLogoGet(requestParameters: CompanyViewLogoLogoGetRequest): Promise<Blob> {
        const response = await this.companyViewLogoLogoGetRaw(requestParameters);
        return await response.value();
    }

}
